<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
	<div class="row">
	  <div class="col-12"></div>
	  <div class="col-12">
		<div class="card">
		  <div class="card-content">
			<div class="card-body">
			  <!-- ngx-datatable-filter -->
			  <fieldset class="form-group">
				<div class="row align-items-end mt-0 pagination-body">
					<div class="col-12 col-sm-12 col-md-3 col-lg-3 mb-2">
						<button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Referral Guideline</button>
						
					  </div>
				  <div class="col-12 col-sm-12 col-md-9 col-lg-9 mt-2 mb-1">
					<div class="row-flex">
						<div class="col-flex-2 mb-1 position-relative" placement="top"
                      ngbTooltip="search by  name,email,phone,pan,account number,empcode">
                      <input id="ngx-filter-ref"
                        class="form-control form-control-sm d-inline-block width-300 ml-1 rounded-right shadow searchInput"
                        type="text" placeholder="Search" #name [(ngModel)]="searchVal"
                        (keydown.enter)="filter(searchVal)" />
                      <button class="btn search-btn glow position-absolute" (click)="filter(searchVal)">
                        <i class="ft-search text-white cursor-pointer"></i>
                      </button>
                    </div>
                    <div class="col-flex-2 mb-1">
                      <button class="btn btn-primary btn-block users-list-clear glow mb-0" (click)="resetFilter()">
                        Reset
                        <i class="ft-filter text-white cursor-pointer"></i>
                      </button>
                    </div>
					</div>
				  </div>
				  <div class="col-12">
					<div class="btn-group" role="group">
							 <button class="btn enrollment-list-buttons cursor-pointer" type="button"
								*ngFor="let status of referral_status"
								[ngClass]="{'btn-primary':activeTab ==status?._id,'btn-outline-primary':activeTab!=status?._id}"
								(click)="activeStatusTab(status?._id)">{{status.name}}</button>
						</div>
				  </div>
					<div class="col-12 filter">
						<ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="40"
						[footerHeight]="40" rowHeight="auto" [limit]="limitRef" [rows]="rows" [externalPaging]="true"
						[count]="page.totalPages" [offset]="page.pageNumber" (page)="pageChangeData($event)"></ngx-datatable>
				  </div>
				</div>
			  </fieldset>
			  <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force" [headerHeight]="50"
				[footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows" [scrollbarH]="true"
				[columns]="columns" [externalPaging]="true" [count]="page.totalPages" [offset]="page.offset"
				(page)="pageChangeData($event)">
				<ngx-datatable-column name="Name" prop="name" [width]="60">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="d-flex align-items-center">
					  <!-- <img
						class="rounded-circle mr-1"
						*ngIf="row.image"
						[src]="imageUrl + row.image"
						height="32"
						width="32"
					  /> -->
					  <div class="avatar mr-1 ml-0 bg-primary">
						<div class="avatar-content">
						  {{ row?.name | shortName }}
						</div>
					  </div>
  
					  <div class="cell-line-height cursor-pointer">
						<p class="font-medium-1 line-height-1 mb-0">
						  {{ row?.name }}
						</p>
						<!-- <span *ngIf="row.roles ==='student'" [ngClass]="{'text-primary': row.roles ==='student' }" class="font-small-2 mt-1">
							{{row.roles}}
						</span>
						<span *ngIf="row.roles ==='employee'" [ngClass]="{'text-success': row.roles ==='employee' }" class="font-small-2 mt-1">
							{{row.roles}}
						</span>
						<span *ngIf="row.roles ==='guest'" [ngClass]="{'text-info': row.roles ==='guest' }" class="font-small-2 mt-1">
							{{row.roles}}
						</span>
						<span *ngIf="row.roles ==='admin'" [ngClass]="{'text-danger': row.roles ==='admin' }" class="font-small-2 mt-1">
							{{row.roles}}
						</span> -->
					  </div>
					</div>
				  </ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Role" prop="roles" [width]="30">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<span *ngIf="row?.roles ==='student'" [ngClass]="{'badge bg-light-primary': row?.roles ==='student'}">{{row?.roles}}</span>
						<span *ngIf="row?.roles ==='employee'" [ngClass]="{'badge bg-light-success': row?.roles ==='employee'}">{{row?.roles}}</span>
						<span *ngIf="row?.roles ==='guest'" [ngClass]="{'badge bg-light-info': row?.roles ==='guest'}">{{row?.roles}}</span>
						<span *ngIf="row?.roles ==='admin'" [ngClass]="{'badge bg-light-primary': row?.roles ==='admin'}">{{row?.roles}}</span>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Email" prop="email" [width]="40">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p class="email-text">{{row?.email}}</p>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Phone" prop="phone" [width]="40">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p>{{row?.phone}}</p>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Referral By" prop="refrence_by" [width]="40">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<span class="cursor-pointer" (click)="openModalForRefOrReport(myModal,row?._id,row?.refrence_by?._id,row?.name,'Referral By')">{{row?.refrence_by?.name}}</span>
					</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Report To" prop="report_to" [width]="30">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					  <span class="cursor-pointer" (click)="openModalForRefOrReport(myModal,row?._id,row?.report_to?._id,row?.name,'Report To')">{{row?.report_to?.name}}</span>
					</ng-template>
				</ngx-datatable-column>
				<!-- <ngx-datatable-column name="Refrence" prop="references" [width]="250">
				  <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
					<div class="boxxx" *ngFor="let ref of row?.references ; last as isLast" >
					  <span>{{ref?.name}} 
						<span *ngIf="ref.roles ==='student'" [ngClass]="{'badge bg-light-primary': ref.roles ==='student'}">{{ref.roles}}</span>
						<span *ngIf="ref.roles ==='employee'" [ngClass]="{'badge bg-light-success': ref.roles ==='employee'}">{{ref.roles}}</span>
						<span *ngIf="ref.roles ==='guest'" [ngClass]="{'badge bg-light-info': ref.roles ==='guest'}">{{ref.roles}}</span>
					  </span>
					  <span *ngIf="ref?.name?.length>1 && !isLast">&nbsp;,&nbsp;</span>
					</div>
				  </ng-template>
				</ngx-datatable-column> -->
				<ngx-datatable-column name="Status" prop="status" [width]="30">
					<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
						<p [matMenuTriggerFor]="status">
							<span *ngIf="row?.status == 'interested'"
								[ngClass]="{'bg-light-success badge badge-pill  cursor-pointer':row?.status == 'interested'}">
								{{row?.status}}
							</span>
							<span *ngIf="row?.status == 'irrelevant'"
								[ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer':row?.status == 'irrelevant'}">
								{{row?.status}}
							</span>
							<span *ngIf="row?.status == 'referred'"
								[ngClass]="{'bg-light-success badge badge-pill  cursor-pointer':row?.status == 'referred'}">
								{{row?.status}}
							</span>
							<span *ngIf="row?.status == 'frequent'"
								[ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer':row?.status == 'frequent'}">
								{{row?.status}}
							</span>
							<span *ngIf="row?.status == 'informed'"
								[ngClass]="{'bg-light-success badge badge-pill  cursor-pointer':row?.status == 'informed'}">
								{{row?.status}}
							</span>
							<span *ngIf="row?.status == 'not_interested'"
								[ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer':row?.status == 'not_interested'}">
								{{row?.status}}
							</span>
							<span *ngIf="row?.status == 'not_informed'"
								[ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer':row?.status == 'not_informed'}">
								{{row?.status}}
							</span>
						</p>
						<mat-menu #status="matMenu">
						  <div *ngFor="let status of referral_status">
							<button mat-menu-item  *ngIf="status._id !== row?.status"
							  (click)="updateReferralStatus(row?._id,status._id)">
							  <span>
							  <span  *ngIf="status.name === 'Interested'"  [ngClass]="{'bg-light-success badge badge-pill  cursor-pointer': status.name === 'Interested'}"
								>{{status.name}}</span>
							  <span *ngIf="status.name ==='Irrelevant'" [ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer': status.name === 'Irrelevant'}"
								>{{status.name}}</span>
							   <span  *ngIf="status.name === 'Referred'"  [ngClass]="{'bg-light-info badge badge-pill  cursor-pointer': status.name === 'Referred'}"
								>{{status.name}}</span>
							  <span *ngIf="status.name ==='Frequent'" [ngClass]="{'bg-light-secondary badge badge-pill  cursor-pointer': status.name === 'Frequent'}"
								>{{status.name}}</span>
								<span  *ngIf="status.name === 'Informed'"  [ngClass]="{'bg-light-info badge badge-pill  cursor-pointer': status.name === 'Informed'}"
								>{{status.name}}</span>
							  <span *ngIf="status.name ==='Not Interested'" [ngClass]="{'bg-light-secondary badge badge-pill  cursor-pointer': status.name === 'Not Interested'}"
								>{{status.name}}</span>
								 <span *ngIf="status.name ==='Not Informed'" [ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer': status.name === 'Not Informed'}"
								>{{status.name}}</span>
							  </span>
							</button>
							</div>
						</mat-menu>
						</ng-template>
				</ngx-datatable-column>
				<ngx-datatable-column name="Actions" [width]="40"
				  *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
				  <ng-template let-row="row" ngx-datatable-cell-template>
					<i mat-button [matMenuTriggerFor]="menu"
                    class="ft-more-vertical text-primary cursor-pointer mx-1"></i>
					<i class="ft-link text-primary cursor-pointer mx-1" (click)="copyReferralLink(row?.refrence_id)" placement="top" ngbTooltip="Referral link"></i>
					  <mat-menu #menu="matMenu">
						<button mat-menu-item
						(click)="openModalReferral(myModalReferrals,row?.references,row?.name)">View Referrals</button>
						<button *ngIf=" activeTab ==='archived' && user_role.roles =='admin' " mat-menu-item (click)="ConfirmColor(row._id)">Delete</button>
  
					  </mat-menu>
					<i class="icon-note text-primary cursor-pointer mx-1" placement="top" ngbTooltip="notes" (click)="openModalNotesAdminNotes(myModal22,row?.notes,row?._id,'Notes',row?.name)"></i>
					<i class="icon-note text-secondry cursor-pointer mx-1" placement="top" ngbTooltip="admin notes" (click)="openModalNotesAdminNotes(myModal22,row?.admin_notes,row?._id,'Admin Notes',row?.name)"></i>

				  </ng-template>
				</ngx-datatable-column>
			  </ngx-datatable>
			  <!-- ngx-datatable-filter -->
			</div>
		  </div>
		</div>
	  </div>
	</div>
  </section>
  <!--/ Filter Datatables -->
  <div class="d-flex justify-content-between align-items-center">
	<ngx-spinner></ngx-spinner>
  </div>
  
  <div #dynamicContainer></div>

  <!-------------- Referral list  Popup ------------------------------------------->
<div>
	<ng-template #myModalReferrals let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">{{row_name}}'s Referrals</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<ngx-datatable [rows]="row_referrals" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="10"
		  [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50">
		  <ngx-datatable-column name="Name" prop="name" [width]="50">
			<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
			  <div class="d-flex align-items-center">
				{{row?.name}}
			  </div>
			</ng-template>
		  </ngx-datatable-column>
		  <ngx-datatable-column name="Email" prop="email" [width]="50">
			<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				<p class="email-text">{{row?.email}}</p>
			</ng-template>
		  </ngx-datatable-column>
		  <ngx-datatable-column name="Report To" prop="report_to" [width]="30">
			<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
			  <span>{{row?.report_to?.name}}</span>
			</ng-template>
		  </ngx-datatable-column>
		  <ngx-datatable-column name="Role" prop="roles" [width]="10">
			<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				<span *ngIf="row?.roles ==='student'" [ngClass]="{'badge bg-light-primary': row?.roles ==='student'}">{{row?.roles}}</span>
				<span *ngIf="row?.roles ==='employee'" [ngClass]="{'badge bg-light-success': row?.roles ==='employee'}">{{row?.roles}}</span>
				<span *ngIf="row?.roles ==='guest'" [ngClass]="{'badge bg-light-info': row?.roles ==='guest'}">{{row?.roles}}</span>
			</ng-template>
		  </ngx-datatable-column>
		  <ngx-datatable-column name="Status" prop="status" [width]="30">
			<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
				<p [matMenuTriggerFor]="status">
					<span *ngIf="row?.status == 'current'"
						[ngClass]="{'bg-light-success badge badge-pill cursor-pointer':row?.status == 'current'}">
						{{row?.status}}
					</span>
					<span *ngIf="row?.status == 'archived'"
						[ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer':row?.status == 'archived'}">
						{{row?.status}}
					</span>
				</p>
				<mat-menu #status="matMenu">
				  <div *ngFor="let status of referral_status">
					<button mat-menu-item  *ngIf="status._id !== row?.status"
					  (click)="updateReferralStatus(row?._id,status._id)">
					  <span>
					  <span  *ngIf="status.name === 'Current'"  [ngClass]="{'bg-light-success badge badge-pill  cursor-pointer': status.name === 'Current'}"
						>{{status.name}}</span>
					  <span *ngIf="status.name ==='Archived'" [ngClass]="{'bg-light-danger badge badge-pill  cursor-pointer': status.name === 'Archived'}"
						>{{status.name}}</span>
					  </span>
					</button>
					</div>
				</mat-menu>
				</ng-template>
		  </ngx-datatable-column>

		  <!-- <ngx-datatable-column name="Action" [width]="10">
			<ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
			  <i class="ft-edit text-primary cursor-pointer" (click)="updateContact(row?._id)"></i>
			</ng-template>
		  </ngx-datatable-column> -->
		</ngx-datatable>
	  </div>
	  <!-- <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		</div> -->
	</ng-template>
  </div>
  
  <!-------------- Notes And Admin Notes update Popup ------------------------------------------->
<div>
	<ng-template #myModal22 let-modal>
	  <div class="modal-header">
		<h4 class="modal-title" *ngIf="modal_for ==='Notes'">{{row_name}}'s Notes</h4>
		<h4 class="modal-title" *ngIf="modal_for ==='Admin Notes'">{{row_name}}'s Admin Notes</h4>
  
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<div class="d-flex" *ngIf="modal_for ==='Notes'">
		  <p class="request-box">Notes :</p>&nbsp;&nbsp;
		  <p *ngIf="notes_admin_notes && !isAddUpdate_notes" [innerHTML]="notes_admin_notes"></p>
		  <span *ngIf="!notes_admin_notes && !isAddUpdate_notes">
			<i class="ft-plus text-primary cursor-pointer mx-1 " (click)="isAddUpdate_notes =!isAddUpdate_notes" ></i>
		  </span>
		  <span *ngIf="notes_admin_notes && !isAddUpdate_notes">
			<i class="ft-edit text-primary cursor-pointer mx-1 " (click)="isAddUpdate_notes =!isAddUpdate_notes" ></i>
		  </span>
		</div>
		<div *ngIf="isAddUpdate_notes">
			<textarea class="form-control" name="notes" id="notes" cols="30" rows="4" [(ngModel)]="notes_admin_notes"></textarea>
		</div>
		<div class="d-flex" *ngIf="modal_for ==='Admin Notes'">
			<p class="request-box">Admin Notes :</p> &nbsp;&nbsp;
			<p *ngIf="notes_admin_notes && !isAddUpdate_admin_notes" [innerHTML]="notes_admin_notes" ></p>
			<span *ngIf="!notes_admin_notes && !isAddUpdate_admin_notes">
				<i class="ft-plus text-primary cursor-pointer mx-1 " (click)="isAddUpdate_admin_notes =!isAddUpdate_admin_notes" ></i>
			  </span>
			  <span *ngIf="notes_admin_notes && !isAddUpdate_admin_notes">
				<i class="ft-edit text-primary cursor-pointer mx-1 " (click)="isAddUpdate_admin_notes =!isAddUpdate_admin_notes" ></i>
			  </span>
		</div>
		<div *ngIf="isAddUpdate_admin_notes">
			<textarea class="form-control" name="admin_notes" id="admin_notes" cols="30" rows="4" [(ngModel)]="notes_admin_notes"></textarea>
		</div>
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-primary" (click)="updateNoteAdminNote()">Submit</button>
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		</div>
	</ng-template>
  </div>
<!----------- Update Referral By And Report to -------------------------------- -->
  <div>
	<ng-template #myModal let-modal>
	  <div class="modal-header">
		<h4 class="modal-title">{{row_name}} {{modalFor}} Update</h4>
		<button type="button" class="close" (click)="modal.dismiss()">
		  <span>&times;</span>
		</button>
	  </div>
	  <div class="modal-body">
		<ng-select [items]="empList" bindLabel="name" bindValue="_id" placeholder="Select Employee"
		  [(ngModel)]="selected_ref_report" [ngModelOptions]="{ standalone: true }" (change)="getEmpId($event)"
		  [appendTo]="'body'" [virtualScroll]="true" [clearSearchOnAdd]="true">
		</ng-select>
  
	  </div>
	  <div class="modal-footer">
		<button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
		<button type="button" class="btn btn-primary" (click)="updateRefAndReport()">Submit</button>
	  </div>
	</ng-template>
  </div>